import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface ContestFiltersProps {
  selectedAcademy: string;
  onAcademyChange: (academy: string) => void;
}

const ACADEMIES = [
  "Aix-Marseille",
  "Amiens",
  "Besançon",
  "Bordeaux",
  "Clermont-Ferrand",
  "Corse",
  "Créteil",
  "Dijon",
  "Grenoble",
  "Guadeloupe",
  "Guyane",
  "Lille",
  "Limoges",
  "Lyon",
  "Martinique",
  "Mayotte",
  "Montpellier",
  "Nancy-Metz",
  "Nantes",
  "Nice",
  "Normandie",
  "Orléans-Tours",
  "Paris",
  "Poitiers",
  "Reims",
  "Rennes",
  "Réunion",
  "Strasbourg",
  "Toulouse",
  "Versailles",
  "Autre",
];

export const ContestFilters = ({
  selectedAcademy,
  onAcademyChange,
}: ContestFiltersProps) => {
  return (
    <div className="flex items-center gap-4">
      <Label className="font-semibold">Académie</Label>
      <Select value={selectedAcademy} onValueChange={onAcademyChange}>
        <SelectTrigger className="w-[200px]">
          <SelectValue placeholder="Toutes les académies" />
        </SelectTrigger>
        <SelectContent className="bg-white">
          <SelectItem value="all">Toutes les académies</SelectItem>
          {ACADEMIES.map((academy) => (
            <SelectItem key={academy} value={academy}>
              {academy}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
